import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePurchasesQuoteRequestModel,
  DeletePurchasesQuoteRequestModel,
  SearchPurchasesQuoteRequestModel,
} from '../../../models/purchase-quote-request.model'

@Injectable({
  providedIn: 'root',
})
export class PurchasesQuoteRequestService {
  private baseUrl = environment.baseUrl
  private resource = 'Compras'
  private resourceRequestStatus = 'StatusSolicitacaoCompra'

  constructor(private httpClient: HttpClient) {}

  public createPurchasesQuoteRequest(
    model: CreatePurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/fromproposta/create`,
      model,
    )
  }

  public editPurchasesQuoteRequest(
    model: any,
    // model: EditPurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/edit`,
      model,
    )
  }

  public calcelarTariffPurchase(
    model: any,
    // model: EditPurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cancelar/tarifario`,
      model,
    )
  }

  public deletePurchasesQuoteRequest(
    model: DeletePurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedPurchasesQuoteRequest(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPurchasesQuoteRequestOpen(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/abertas/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listItinerariesByPurchasesQuoteRequestId(
    idRequest: string,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Cotacoes/abertas/listall/${idRequest}`,
    )
  }

  public listPagedPurchasesQuoteOpen(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Cotacoes/abertas/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPurchasesQuoteRequest(
    model: SearchPurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public searchPagedPurchasesQuoteRequest(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedPurchasesQuoteRequestByProposal(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/proposta?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedPurchasesQuoteRequestFromPurchase(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated-solicitacao?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedPurchasesQuoteRequestClose(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/fechada/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPurchasesQuoteRequestCancels(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/canceladas/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public SendEmailSupplier(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/send-email/fornecedor`,
      model,
    )
  }

  public SendEmailConsultant(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/send-email/consultor`,
      model,
    )
  }

  public SendEmailSupplierNewResponse(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/send-email/fornecedor/new-responsavel`,
      model,
    )
  }

  public CreatePurchasesQuoteRequestSupplier(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/cotacao-fornecedor`,
      model,
    )
  }

  public CreatePurchasesQuoteRequestTariff(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/tarifario`,
      model,
    )
  }

  public CreatePurchasesQuoteRequestTariffUnique(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/inactive/tarifario`,
      model,
    )
  }

  public listPagedSearchPurchasesStatus(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/search-status/listpaginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public PurchaseRequestStatus(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceRequestStatus}/listall`,
    )
  }

  // Só é possível recusar enquanto a solicitação estiver Aberta (statusId 1)
  public refusePurchasesQuoteRequest(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/recusar`,
      model,
    )
  }

  public listPagedRefusedQuotes(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/recusadas/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedRefusedQuotes(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/recusadas/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Recebe os mesmos filtros da busca, body vazio exporta todas as recusadas
  public downloadRefusedQuotesExcel(
    model: any = {},
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Solicitacao/recusadas/download-excel`,
      model,
    )
  }

  // Histórico de idas e voltas do Compras (aba SLA). Não existe endpoint de listagem sem
  // filtro: o body é opcional e body vazio traz todo o histórico.
  // Devolve propostas com as rodadas dentro, e totalItens conta PROPOSTAS, não rodadas.
  public searchPagedComprasHistorico(
    page: number,
    rows = 15,
    model: any = {},
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/historico/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Recebe os mesmos filtros da busca e ignora a paginação, body vazio exporta tudo
  public downloadComprasHistoricoExcel(
    model: any = {},
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/historico/download-excel`,
      model,
    )
  }
}
